import {useAtom} from "jotai/index";


function useIntervals(interval_atom:any, refresh_time = false) {
    const [interval, set_resend_interval] = useAtom(interval_atom)
    const queryParams = new URLSearchParams(location.search);
    const debug = queryParams.get("debug")
    
    const setIntervalHandler = () => {
        if(debug === "true") console.info("setInterval is_finalize_good")
        
        if(interval !== null) {
            let currentDate = new Date();
            currentDate.setSeconds(currentDate.getSeconds() + (refresh_time ? 60 : 30));
            
            set_resend_interval(JSON.stringify({interval: currentDate}))
        }
    }
    
    const getInterval = () => {
        return interval
    }
    
    const clear_interval = () => {
        set_resend_interval("")
    }
    
    return {
        setIntervalHandler,
        getInterval,
        clear_interval
    }
}

export default useIntervals